import React from 'react';
import {TabBar, Tab} from 'rmwc';

import Password from './password';
import CellPhone from './cellphone';
import Account from './account';


export default class Profile extends React.PureComponent {
    state = {
        currentTab: 0,
    };

    static tabs = {
        0: 'profile',
        1: 'password',
        2: 'cellphone',
    };

    componentWillMount(){
        // debugger; 
        var item = this.props.location.search;
        if (item !==null && item !=="" && item !== undefined) {
            this.setState({
                currentTab : 2 
            });
        }
    }

    render() {
        return <span>
            <TabBar
                activeTabIndex={this.state.currentTab}
                onChange={({target: {value}}) => this.setState({currentTab: value})}>
                <Tab>{'اطلاعات کاربری'}</Tab>
                <Tab>{window.gettext('Password')}</Tab>
                <Tab>{window.gettext('CellPhone')}</Tab>
            </TabBar>
            {( () => {
                if (Profile.tabs[this.state.currentTab] === 'password')
                    return <Password {...this.props}/>;
                else if (Profile.tabs[this.state.currentTab] === 'cellphone')
                    return <CellPhone {...this.props}/>;
                else if (Profile.tabs[this.state.currentTab] === 'profile')
                    return <Account {...this.props}/>;
            })()}
        </span>;
    }
}
